export default "__VITE_ASSET__Drk_5Zow__"